
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6z74O", function(module, exports) {
/* ContributorsMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $i8KfB = parcelRequire("i8KfB");


var $jMyy4 = parcelRequire("jMyy4");

const $091a88986b4982de$export$942f501e41d4af36 = ({ contentId: contentId, skip: skip, macroParams: macroParams })=>{
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $i8KfB.default), {
        variables: {
            contentId: contentId,
            contentStatus: [
                'current'
            ],
            contributorsMacroParameters: macroParams ?? undefined
        },
        skip: skip,
        __callerPackage__: "@confluence/contributors-macro"
    });
    return {
        data: data?.singleContent?.contributorsMacro ? data : undefined,
        loading: false,
        error: error ?? null
    };
};





const $4e61a88dc657dd37$var$ANONYMOUS_USER_ID = 'anonymous';
const $4e61a88dc657dd37$var$getComparator = (order)=>{
    switch(order){
        case 'name':
            return (a, b)=>a.fullName.localeCompare(b.fullName);
        case 'update':
            return (a, b)=>b.lastActiveTime - a.lastActiveTime;
        case 'edits':
            return (a, b)=>b.edits - a.edits;
        case 'editTime':
            return (a, b)=>b.lastEditTime - a.lastEditTime;
        case 'count':
        default:
            return (a, b)=>b.totalCount - a.totalCount;
    }
};
const $4e61a88dc657dd37$var$hasContributionInIncludedTypes = (contributor, include)=>{
    return include.some((type)=>{
        switch(type){
            case 'authors':
                return contributor.edits > 0;
            case 'comments':
                return contributor.comments > 0;
            case 'labels':
                return contributor.labels > 0;
            case 'watches':
                return contributor.watches > 0;
            default:
                return false;
        }
    });
};
const $4e61a88dc657dd37$export$cf4681f9c9c1bbb6 = (ranking)=>{
    if (!ranking) return [];
    const result = [];
    for (const author of ranking){
        if (author == null) continue;
        const edits = author.edits ?? 0;
        const comments = author.comments ?? 0;
        const labels = author.labels ?? 0;
        const watches = author.watches ?? 0;
        const lastEditTime = author.lastEditTime ?? 0;
        const lastCommentTime = author.lastCommentTime ?? 0;
        const lastLabelTime = author.lastLabelTime ?? 0;
        const lastActiveTime = Math.max(lastEditTime, lastCommentTime, lastLabelTime);
        result.push({
            id: author.idString ?? '',
            fullName: author.fullNameString ?? '',
            totalCount: edits + comments + labels + watches,
            edits: edits,
            comments: comments,
            labels: labels,
            watches: watches,
            lastActiveTime: lastActiveTime,
            lastEditTime: lastEditTime
        });
    }
    return result;
};
const $4e61a88dc657dd37$export$19399e0326061ee2 = ({ data: data, include: include, order: order, reverse: reverse, showAnonymous: showAnonymous, limit: limit })=>{
    return (0, $42omo.useMemo)(()=>{
        const contentNode = data?.singleContent;
        const authorRankingList = contentNode?.contributorsMacro?.authorRankingList;
        let contributors = $4e61a88dc657dd37$export$cf4681f9c9c1bbb6(authorRankingList ?? null);
        // Filter out anonymous user if not wanted
        if (!showAnonymous) contributors = contributors.filter((c)=>c.id !== $4e61a88dc657dd37$var$ANONYMOUS_USER_ID);
        // Filter by contribution types
        contributors = contributors.filter((c)=>$4e61a88dc657dd37$var$hasContributionInIncludedTypes(c, include));
        // Sort
        const comparator = $4e61a88dc657dd37$var$getComparator(order);
        contributors.sort(reverse ? (a, b)=>comparator(b, a) : comparator);
        // Split into visible and hidden
        const noLimit = limit <= -1;
        let visibleContributors;
        let hiddenContributors;
        if (!noLimit && limit < contributors.length) {
            visibleContributors = contributors.slice(0, limit);
            hiddenContributors = contributors.slice(limit);
        } else {
            visibleContributors = contributors;
            hiddenContributors = [];
        }
        return {
            visibleContributors: visibleContributors,
            hiddenContributors: hiddenContributors
        };
    }, [
        data,
        include,
        order,
        reverse,
        showAnonymous,
        limit
    ]);
};



var $f21pt = parcelRequire("f21pt");




const $20212570a886ccb2$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    showMoreTooltip: {
        id: "contributors-macro.show-more-tooltip",
        defaultMessage: "{count} more..."
    },
    showMoreLabel: {
        id: "contributors-macro.show-more-label",
        defaultMessage: "..."
    },
    noContributorsDefault: {
        id: "contributors-macro.no-contributors-default",
        defaultMessage: "No contributors found for: {includeTypes} on selected page(s)"
    },
    errorPreview: {
        id: "contributors-macro.error-preview",
        defaultMessage: "{macroLabel} will be shown when you save your edit"
    },
    errorUnsupportedContent: {
        id: "contributors-macro.error-unsupported-content",
        defaultMessage: "{macroLabel} can only be used in pages, blog posts and comments"
    },
    error: {
        id: "contributors-macro.error",
        defaultMessage: "We're unable to display the contributors. Refresh to try again"
    },
    macroLabel: {
        id: "contributors-macro.label",
        defaultMessage: "Contributors"
    },
    separator: {
        id: "contributors-macro.separator",
        defaultMessage: ", "
    },
    lastActiveTime: {
        id: "contributors-macro.last-active-time",
        defaultMessage: "({time})"
    }
});


/* FlatLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


/* ContributorItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $auNCB = parcelRequire("auNCB");






var $eZ4zi = parcelRequire("eZ4zi");


const $5688b5b2217a5458$var$styles = {
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $5688b5b2217a5458$export$c4b574419b8155b = ({ contributor: contributor, showCount: showCount, showTime: showTime })=>{
    const profileUrl = `/wiki/display/~${contributor.id}`;
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        as: "span",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        testId: `contributor-link-${contributor.id}`,
        href: profileUrl,
        target: "_blank",
        xcss: $5688b5b2217a5458$var$styles.anchor
    }, contributor.fullName), showCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        testId: `contributor-count-${contributor.id}`
    }, contributor.totalCount), showTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        testId: `contributor-time-${contributor.id}`
    }, intl.formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).lastActiveTime, {
        time: (0, $eZ4zi.getRelativeTime)(contributor.lastActiveTime, intl)
    })));
};


const $961a6dfcb49cfabe$var$styles = {
    showMoreButton: "_1yt4ze3t _bfhk1j28"
};
const $961a6dfcb49cfabe$export$672b5f7bc032ce43 = ({ visibleContributors: visibleContributors, hiddenContributors: hiddenContributors, showCount: showCount, showTime: showTime })=>{
    const [showHidden, setShowHidden] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleShowMore = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setShowHidden(true);
    }, [
        setShowHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        as: "span",
        testId: "contributors-flat-layout",
        shouldWrap: true
    }, visibleContributors.map((contributor, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            key: contributor.id
        }, index > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $20212570a886ccb2$export$a7357cdd1f0b0168).separator), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5688b5b2217a5458$export$c4b574419b8155b), {
            contributor: contributor,
            showCount: showCount,
            showTime: showTime
        }))), hiddenContributors.length > 0 && !showHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "end"
    }, visibleContributors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $20212570a886ccb2$export$a7357cdd1f0b0168).separator), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $961a6dfcb49cfabe$var$styles.showMoreButton,
        testId: "contributors-show-more",
        onClick: handleShowMore,
        title: formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).showMoreTooltip, {
            count: hiddenContributors.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $20212570a886ccb2$export$a7357cdd1f0b0168).showMoreLabel))), showHidden && hiddenContributors.map((contributor, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            key: contributor.id
        }, (visibleContributors.length > 0 || index > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $20212570a886ccb2$export$a7357cdd1f0b0168).separator), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5688b5b2217a5458$export$c4b574419b8155b), {
            contributor: contributor,
            showCount: showCount,
            showTime: showTime
        }))));
};


/* ListLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $eyWa4 = parcelRequire("eyWa4");



const $29376cf569006e15$var$styles = {
    list: "_bozg1ejb",
    showMoreButton: "_1yt4ze3t _bfhk1j28"
};
const $29376cf569006e15$export$cacbb3924155d68e = ({ visibleContributors: visibleContributors, hiddenContributors: hiddenContributors, showCount: showCount, showTime: showTime })=>{
    const [showHidden, setShowHidden] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleShowMore = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setShowHidden(true);
    }, [
        setShowHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        as: "ul",
        xcss: $29376cf569006e15$var$styles.list,
        testId: "contributors-list-layout"
    }, visibleContributors.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
            key: contributor.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5688b5b2217a5458$export$c4b574419b8155b), {
            contributor: contributor,
            showCount: showCount,
            showTime: showTime
        }))), hiddenContributors.length > 0 && !showHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $29376cf569006e15$var$styles.showMoreButton,
        testId: "contributors-show-more",
        onClick: handleShowMore,
        title: formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).showMoreTooltip, {
            count: hiddenContributors.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $20212570a886ccb2$export$a7357cdd1f0b0168).showMoreLabel))), showHidden && hiddenContributors.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
            key: contributor.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5688b5b2217a5458$export$c4b574419b8155b), {
            contributor: contributor,
            showCount: showCount,
            showTime: showTime
        }))));
};


const $003fae4a0b54ead2$var$styles = {
    container: "_1e0c1o8l"
};
const $003fae4a0b54ead2$var$ContributorsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { include: include, order: order, reverse: reverse, limit: limit, mode: mode, showAnonymous: showAnonymous, showCount: showCount, showTime: showTime, noneFoundMessage: noneFoundMessage, macroParamsForQuery: macroParamsForQuery } = (0, $f21pt.useParsedMacroParams)(macroParams);
    const { data: data, error: error } = (0, $091a88986b4982de$export$942f501e41d4af36)({
        contentId: macroDefaultProps.contentId,
        macroParams: macroParamsForQuery
    });
    const { visibleContributors: visibleContributors, hiddenContributors: hiddenContributors } = (0, $4e61a88dc657dd37$export$19399e0326061ee2)({
        data: data,
        include: include,
        order: order,
        reverse: reverse,
        showAnonymous: showAnonymous,
        limit: limit
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: new Error(formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).error))
    });
    if (visibleContributors.length === 0 && hiddenContributors.length === 0) {
        const message = noneFoundMessage || formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).noContributorsDefault, {
            includeTypes: include.join(', ')
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: "contributors-empty-state"
        }, message);
    }
    const LayoutComponent = mode === 'list' ? (0, $29376cf569006e15$export$cacbb3924155d68e) : (0, $961a6dfcb49cfabe$export$672b5f7bc032ce43);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $003fae4a0b54ead2$var$styles.container,
        testId: "contributors-macro",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        "data-macro-body": ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LayoutComponent, {
        visibleContributors: visibleContributors,
        hiddenContributors: hiddenContributors,
        showCount: showCount,
        showTime: showTime
    }));
};
const $003fae4a0b54ead2$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $20212570a886ccb2$export$a7357cdd1f0b0168).error);
const $003fae4a0b54ead2$export$bdd5e2945207ab45 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $003fae4a0b54ead2$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($003fae4a0b54ead2$var$ContributorsMacroRendererComponent, props));
};
module.exports["ContributorsMacroRenderer"] = $003fae4a0b54ead2$export$bdd5e2945207ab45;

});

parcelRegister("i8KfB", function(module, exports) {
/**
 * @generated SignedSource<<4c4abbfc511dda1fb14b844c0b388995>>
 * @relayHash ca950652c375632e8e3242fc2e8e313a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3
const $2e401621b9e1fde0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contributorsMacroParameters"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contributorsMacroParameters",
                            "variableName": "contributorsMacroParameters"
                        }
                    ],
                    "concreteType": "ConfluenceContributorsRankings",
                    "kind": "LinkedField",
                    "name": "contributorsMacro",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceAuthorRanking",
                            "kind": "LinkedField",
                            "name": "authorRankingList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "idString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "fullNameString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "edits"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "comments"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "labels"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "watches"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastEditTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastCommentTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastLabelTime"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ca950652c375632e8e3242fc2e8e313a",
            "id": "d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3",
            "metadata": {},
            "name": "useContributorsDataQuery",
            "operationKind": "query",
            "text": "query useContributorsDataQuery($contentId:ID,$contentStatus:[String],$contributorsMacroParameters:ConfluenceContributorsMacroParametersModel){singleContent(id:$contentId,status:$contentStatus){id,contributorsMacro(contributorsMacroParameters:$contributorsMacroParameters){authorRankingList{idString,fullNameString,edits,comments,labels,watches,lastEditTime,lastCommentTime,lastLabelTime}}}}"
        }
    };
}();
$2e401621b9e1fde0$var$node.hash = "2b1ea1963eb971919228dd0de7168930";
var $2e401621b9e1fde0$export$2e2bcd8739ae039 = $2e401621b9e1fde0$var$node;
module.exports["default"] = $2e401621b9e1fde0$export$2e2bcd8739ae039;

});

parcelRegister("f21pt", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $66904c9443eb5472$export$8bf632d40c0a848b = (value)=>{
    if (!value) return [
        'authors'
    ];
    return value.split(',').map((s)=>s.trim());
};
const $66904c9443eb5472$export$4c17d9c0cb17e4cf = (value)=>{
    const validOrders = [
        'count',
        'name',
        'update',
        'edits',
        'editTime'
    ];
    if (value && validOrders.includes(value)) return value;
    return 'count';
};
const $66904c9443eb5472$export$3fb54149990fb5b5 = (value)=>{
    return value === 'true';
};
const $66904c9443eb5472$export$a122018e819bbb5 = (value)=>{
    if (!value) return -1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? -1 : Math.max(parsed, -1);
};
const $66904c9443eb5472$export$8f0d03faf499ec50 = (macroParams)=>{
    const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
    const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
    return {
        include: macroParams?.include?.value,
        order: macroParams?.order?.value,
        reverse: reverse,
        showAnonymous: showAnonymous,
        page: macroParams?.page?.value,
        labels: macroParams?.labels?.value,
        label: macroParams?.label?.value,
        spaces: macroParams?.spaces?.value,
        space: macroParams?.space?.value,
        contentType: macroParams?.contentType?.value,
        publishDate: macroParams?.publishDate?.value,
        scope: macroParams?.scope?.value
    };
};
const $66904c9443eb5472$export$2f9066b0466085e = (macroParams)=>{
    return (0, $42omo.useMemo)(()=>{
        const include = $66904c9443eb5472$export$8bf632d40c0a848b(macroParams?.include?.value);
        const order = $66904c9443eb5472$export$4c17d9c0cb17e4cf(macroParams?.order?.value);
        const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
        const limit = $66904c9443eb5472$export$a122018e819bbb5(macroParams?.limit?.value);
        const mode = macroParams?.mode?.value === 'list' ? 'list' : 'inline';
        const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
        const showCount = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showCount?.value);
        const showTime = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showLastTime?.value);
        const noneFoundMessage = macroParams?.noneFoundMessage?.value;
        const macroParamsForQuery = $66904c9443eb5472$export$8f0d03faf499ec50(macroParams);
        return {
            include: include,
            order: order,
            reverse: reverse,
            limit: limit,
            mode: mode,
            showAnonymous: showAnonymous,
            showCount: showCount,
            showTime: showTime,
            noneFoundMessage: noneFoundMessage,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams
    ]);
};
module.exports["composeMacroParamsForQuery"] = $66904c9443eb5472$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $66904c9443eb5472$export$2f9066b0466085e;

});

parcelRegister("eZ4zi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $aXWIB.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    }
});
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;

});


//# sourceMappingURL=ContributorsMacroRenderer.d037be26.js.map
